import { FormGroup } from '@angular/forms';
import { createPersonForm } from '@base/factories/person-form.factory';
import { createPaymentForm } from '@base/factories/payment-form.factory';
import { createLegalCheckForm, KaufpreisLegalCheckFormModel } from './kaufpreis-legal-check-form.factory';
import { PersonFormModel } from '@base/models/form/person-form.model';
import { PaymentFormModel } from '@base/models/form/payment-form.model';
import { createKaufpreisProductForm, KaufpreisProductFormModel } from './kaufpreis-product-form.factory';

export function createKaufpreisForm(): FormGroup<KaufpreisFormModel> {
  return new FormGroup<KaufpreisFormModel>({
    person: createPersonForm(),
    product: createKaufpreisProductForm(),
    payment: createPaymentForm(),
    legalCheck: createLegalCheckForm()
  });
}

export interface KaufpreisFormModel {
  person: FormGroup<PersonFormModel>;
  product: FormGroup<KaufpreisProductFormModel>;
  payment: FormGroup<PaymentFormModel>;
  legalCheck: FormGroup<KaufpreisLegalCheckFormModel>;
}
